import { render, staticRenderFns } from "./MainBg.vue?vue&type=template&id=02184cb4&scoped=true&"
import script from "./MainBg.vue?vue&type=script&lang=js&"
export * from "./MainBg.vue?vue&type=script&lang=js&"
import style0 from "./MainBg.vue?vue&type=style&index=0&id=02184cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02184cb4",
  null
  
)

export default component.exports